import { Box, Typography, styled } from '@mui/material';

export const PlanCardFooterStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  borderTop: '1px solid #E6E6E6',
  alignItems: 'center',
  width: '100%',
  padding: '24px 40px 25px 40px',
  margin: '0px',
  '@media (min-width: 744px)': {
    height: '89px',
  },
  '@media (max-width: 743px)': {
    flexDirection: 'column',
  },
});

export const PlanCardHeaderSyled = styled(Box)({
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '4px',
});

export const PlanCardIconStyled = styled(Box)({
  backgroundColor: '#ae70ff',
  borderRadius: '4px 0px 8px 0px',
  width: '40px',
  height: '72px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const PlanNameStyled = styled(Typography)({
  fontSize: 19,
  fontWeight: 600,
  marginLeft: '20px',
}) as typeof Typography;

export const CarrierLogoBoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  marginRight: '40px',
  height: '64px',
  // Adding a media query for mobile phone viewports
  [theme.breakpoints.down('sm')]: {
    marginRight: 'auto',
  },
}));

export const PlanCardIneligibleBanner = styled(Box)({
  margin: '23px 40px 23px  40px',
});

export const FooterCompareCarrierLogoBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '36px',
});

export const CompareCarrierLogoBoxStyled = styled(Box)({
  display: 'flex',
  textAlign: 'center',
  '@media (min-width: 744px)': {
    alignItems: 'center',
    width: '180px',
    height: '84px',
    borderRadius: '6px',
    border: `1px solid #BBC1D0`,
    padding: '3rem',
  },
  '@media (max-width: 743px)': {
    height: '24px',
  },
});

export const AddToCompareStyled = styled(Box)({
  '@media (max-width: 743px)': {
    margin: '0 auto',
  },
});
